import React from "react";
import { toast } from "react-toastify";

const OverviewPage = ({ credentials, kycViewData, vid, topupForm, setTopupForm, handleTopUpSubmit, isTopupLoading, handleWebhookUpdate, webhookUrl, setWebhookUrl }) => {
  const handleCopyVid = () => {
    navigator.clipboard.writeText(vid);
    toast.success("vid copied");
  };

  return (
    <div className="view-container">
      <div className="page-header" style={{ marginBottom: '2.5rem' }}>
        <h1 style={{ fontSize: '1.8rem', fontWeight: 700 }}>Dashboard Overview</h1>
        <p style={{ color: 'var(--text-muted)' }}>Monitor your balance and infrastructure settings.</p>
      </div>

      <div className="stats-row">
        <div className="card" style={{ borderLeft: '4px solid var(--primary)' }}>
          <span style={{ fontSize: '0.75rem', color: 'var(--text-muted)', textTransform: 'uppercase', fontWeight: 700 }}>balance</span>
          <h2 style={{ fontSize: '1.75rem', marginTop: '8px' }}>KES {parseFloat(credentials?.credits || 0).toLocaleString(undefined, { minimumFractionDigits: 2 })}</h2>
        </div>
        <div className="card">
          <span style={{ fontSize: '0.75rem', color: 'var(--text-muted)', textTransform: 'uppercase', fontWeight: 700 }}>rate per sms</span>
          <h2 style={{ fontSize: '1.75rem', marginTop: '8px' }}>KES {credentials?.rate || "0.00"}</h2>
        </div>
        <div className="card">
          <span style={{ fontSize: '0.75rem', color: 'var(--text-muted)', textTransform: 'uppercase', fontWeight: 700 }}>KYC compliance</span>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '8px' }}>
            <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: kycViewData ? 'var(--success)' : 'var(--warning)' }}></div>
            <h2 style={{ fontSize: '1.2rem', color: kycViewData ? 'var(--success)' : 'var(--warning)' }}>{kycViewData ? "Fully Compliant" : "Action Required"}</h2>
          </div>
        </div>
      </div>

      <div className="panel-grid" style={{ gridTemplateColumns: '1.2fr 1fr' }}>
        <div className="card">
          <h2 className="card-title">top up</h2>
          <form onSubmit={handleTopUpSubmit}>
            <label className="form-label">mobile number</label>
            <input type="tel" className="form-input" required value={topupForm.phone_number} onChange={e => setTopupForm({ ...topupForm, phone_number: e.target.value })} placeholder="2547XXXXXXXX" />
            <label className="form-label">amount</label>
            <input type="number" className="form-input" min="1000" required value={topupForm.amount} onChange={e => setTopupForm({ ...topupForm, amount: e.target.value })} placeholder="Minimum 1,000 KES" />
            <button type="submit" className="btn-primary" disabled={isTopupLoading}>Trigger KES STK Push</button>
          </form>
        </div>

        <div className="card">
          <h2 className="card-title">Credentials</h2>
          <label className="form-label">vid</label>
          <div style={{ display: "flex", gap: "0.5rem", alignItems: "center", background: "#111827", padding: "0.75rem 1rem", borderRadius: "10px", border: "1px solid var(--border)", marginBottom: '1.5rem' }}>
            <span style={{ flex: 1, fontFamily: "monospace", color: "var(--primary)", fontWeight: 600 }}>{vid}</span>
            <button type="button" style={{ background: 'none', border: 'none', color: 'var(--primary)', cursor: 'pointer', fontWeight: 600, fontSize: '0.8rem' }} onClick={handleCopyVid}>COPY</button>
          </div>
          <label className="form-label">Webhook URL</label>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <input type="url" className="form-input" placeholder="https://your-domain.xyz/webhooks" value={webhookUrl} onChange={(e) => setWebhookUrl(e.target.value)} style={{ marginBottom: 0 }} />
            <button type="button" className="btn-primary" style={{ width: 'auto' }} onClick={handleWebhookUpdate}>Update</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewPage;